import { TOKEN } from 'constants/index'

const LOGIN_FAILED_PREFIX = 'loginFailed:'

const getLoginFailedKey = ({ operatorId, currencyCode, operatorUserToken }) =>
  `${LOGIN_FAILED_PREFIX}${operatorId ?? ''}:${currencyCode ?? ''}:${operatorUserToken ?? ''}`

export const hasLoginFailed = (creds) =>
  window.sessionStorage.getItem(getLoginFailedKey(creds)) === '1'

export const markLoginFailed = (creds) => {
  window.sessionStorage.setItem(getLoginFailedKey(creds), '1')
}

export const clearLoginFailed = (creds) => {
  window.sessionStorage.removeItem(getLoginFailedKey(creds))
}

/* ==========================================================================
  Auth Token
========================================================================== */
export const getAuthTokenFromCookie = () => {
  return window.sessionStorage.getItem(TOKEN)
}

export const setAuthTokenInCookie = (authAccessToken) => {
  window.sessionStorage.setItem(TOKEN, authAccessToken)
}

export const removeAuthTokenFromCookie = () => {
  window.sessionStorage.removeItem(TOKEN)
}

/* ==========================================================================
  SignIn Action
========================================================================== */
export const signIn = ({ token }) => {
  setAuthTokenInCookie(token)
}

/* ==========================================================================
  SignOut Action
========================================================================== */
export const signOut = () => {
  removeAuthTokenFromCookie()
}
